export enum ValueErrorType {
    None,
    Empty,
    LessThanRequired,
    MoreThanRequired,
    ShorterThanRequired,
    LongerThanRequired,
    FewerThanRequired,
    ExceedsAllowedCount,
}
